"use client";

import { useAuth } from "../lib/hooks/useAuth";
import { Button } from "../components/ui/Button";
import { useEffect, useState } from "react";
import SlideBanner from "../components/landing/SlideBanner";
import CategorySection from "../components/landing/CategorySection";
import RecentItemsSection from "../components/landing/RecentItemsSection";
import PopularCategoriesSection from "../components/landing/PopularCategoriesSection";
import AdvantagesSection from "../components/landing/AdvantagesSection";
import SearchSection from "../components/landing/SearchSection";
import { HomeAIRecommendationSection } from "../components/home/HomeAIRecommendationSection";

export default function HomePage() {
  const { user, loading } = useAuth();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const handleError = (error: ErrorEvent) => {
      console.error("Client-side error:", error);
      setHasError(true);
    };

    window.addEventListener("error", handleError);
    return () => window.removeEventListener("error", handleError);
  }, []);

  if (hasError) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="text-center max-w-md">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            문제가 발생했습니다
          </h2>
          <p className="text-gray-600 mb-6">
            예상치 못한 오류가 발생했습니다. 잠시 후 다시 시도해주세요.
          </p>
          <Button onClick={() => window.location.reload()}>
            다시 시도
          </Button>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#7A56E8]"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white pb-24 md:pb-0">
      {/* Hero Section - 슬라이드 배너 */}
      <SlideBanner user={user} />

      {/* 전 분야 악기 카테고리 섹션 */}
      <div className="bg-white shadow-[0_2px_8px_rgba(0,0,0,0.04)]">
        <CategorySection />
      </div>

      {/* 검색 섹션 - 카테고리 섹션 바로 아래 */}
      <div className="bg-white shadow-[0_2px_8px_rgba(0,0,0,0.04)]">
        <SearchSection />
      </div>

      {/* AI 맞춤 추천 섹션 (새로 추가된 기능 - 유지) */}
      <HomeAIRecommendationSection />

      {/* 인기 악기 / 인기 카테고리 섹션 */}
      <div className="bg-white shadow-[0_2px_8px_rgba(0,0,0,0.04)]">
        <PopularCategoriesSection />
      </div>

      {/* 서비스 장점 섹션 */}
      <div className="bg-gradient-to-b from-gray-50 to-white">
        <AdvantagesSection />
      </div>
    </div>
  );
}
